var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasPermission
    ? _c(
        "div",
        [
          _vm.entity
            ? _c("router-view", {
                model: {
                  value: _vm.entity,
                  callback: function ($$v) {
                    _vm.entity = $$v
                  },
                  expression: "entity",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _c("div", { staticClass: "container" }, [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("article", { staticClass: "message is-danger" }, [
      _c("div", { staticClass: "message-header" }, [
        _c("p", [
          _c("span", { staticClass: "icon" }, [
            _c("i", { staticClass: "mdi mdi-shield-alert-outline mdi-24px" }),
          ]),
          _c("span", { staticClass: "is-size-4" }, [_vm._v(" Access Denied")]),
        ]),
      ]),
      _c("div", { staticClass: "message-body" }, [
        _vm._v(" You do not have permission to access this page "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }